export const navItems = [
  { id: "search", icon: "S", label: "Søg", visibility: "authenticated" },
  { id: "sales", icon: "M", label: "Mine annoncer", visibility: "authenticated" },
  { id: "favorites", icon: "F", label: "Favoritter", visibility: "authenticated" },
  { id: "messages", icon: "B", label: "Beskeder", visibility: "authenticated" },
  { id: "shop", icon: "🏪", label: "Mini shops", visibility: "authenticated" },
];

export const ROUTE_BY_PAGE = {
  "admin-moderation": "/admin/moderation",
  "create-listing": "/sell/new",
  "edit-listing": "/sell/edit",
  favorites: "/me/favorites",
  "listing-detail": "/listing",
  login: "/login",
  messages: "/messages",
  profile: "/me/profile",
  register: "/register",
  sales: "/me/listings",
  shop: "/me/shop",
  "public-shop": "/shop",
  "shop-create": "/me/shop/items/new",
  "shop-preview": "/me/shop/preview",
  "shop-settings": "/me/shop/settings",
  "shop-stock": "/me/shop/stock",
  search: "/search",
  "seller-profile": "/seller",
};

export function pageFromHash(hash) {
  const route = (hash || "").replace(/^#/, "") || ROUTE_BY_PAGE.search;
  const path = route.split("?")[0];
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return Object.entries(ROUTE_BY_PAGE).find(([, value]) => value === normalizedPath)?.[0] || "search";
}

export function hashForPage(page) {
  return `#${ROUTE_BY_PAGE[page] || ROUTE_BY_PAGE.search}`;
}

export function hashForListing(listingId) {
  return `${hashForPage("listing-detail")}?id=${encodeURIComponent(listingId)}`;
}

export function listingIdFromHash(hash) {
  const query = (hash || "").split("?")[1] || "";
  return new URLSearchParams(query).get("id")?.trim() || "";
}

export function hashForSeller(userId) {
  return `${hashForPage("seller-profile")}?id=${encodeURIComponent(userId)}`;
}

export function hashForShop(shopId) {
  return `${hashForPage("public-shop")}?id=${encodeURIComponent(shopId)}`;
}

export function shopIdFromHash(hash) {
  const query = (hash || "").split("?")[1] || "";
  return new URLSearchParams(query).get("id")?.trim() || "";
}

export function sellerIdFromHash(hash) {
  const query = (hash || "").split("?")[1] || "";
  return new URLSearchParams(query).get("id")?.trim() || "";
}

export function visibleNavItems(auth) {
  return navItems.filter((item) => {
    if (item.visibility === "authenticated") {
      return Boolean(auth);
    }
    if (item.visibility === "guest") {
      return !auth;
    }
    if (item.visibility === "shop_owner") {
      return auth?.user?.role === "shop_owner";
    }
    return true;
  });
}
